export default __webpack_public_path__ + "static/media/after.07940530.png";